import React from "react";
import { Table } from "react-bootstrap";
import { toUSD } from "../../util/currency-formatter";

export default function ReceiveCreditInvoiceBudget({ headerName = "Receive Credit Invoice", creditTotal = 0, actualCostToDate = 0, show = false }) {
  const numericCredit = parseFloat(creditTotal || 0)
  if (!show && numericCredit === 0) return null

  const creditAbs = Math.abs(parseFloat(creditTotal || 0));
  const total = (parseFloat(actualCostToDate || 0)) - creditAbs;
  const hasData = (parseFloat(creditTotal || 0) !== 0) || (parseFloat(actualCostToDate || 0) !== 0)

  return (
    <div className="row mt-2 mb-4">
      <div className="col-12">
        <div className="material-list-block mt-3">
          <h2 className="content-heading text-uppercase mb-0">{headerName}</h2>
          <div className="table-responsive">
            <Table bordered className="table-create table-material table-material-ch">
              <thead>
                <tr>
                  <th className="w-auto">S.No</th>
                  <th className="text-right">Credit Invoice Total</th>
                  <th className="text-right">Actual Cost To Date</th>
                  <th className="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <tr>
                    <td>1</td>
                    <td className="text-right">{toUSD(creditTotal || 0)}</td>
                    <td className="text-right">{toUSD(actualCostToDate || 0)}</td>
                    <td className="text-right">{toUSD(total)}</td>
                  </tr>
                ) : (
                  <tr>
                    <td className="text-center" colSpan={4}>No Data</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  )
}


